import axios from 'axios';

import { useNavigate } from 'react-router-dom';
// @mui
import { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import { Box, Typography, Avatar } from '@mui/material';
import { NAV, HEADER } from '../../../config-global';

// auth
// components
import UserNameService from '../../../services/username.service';
import AppCache from '../../../services/appcache';

// ----------------------------------------------------------------------


const StyledLogo = styled('div')(({ theme }) => ({
    width: NAV.W_DASHBOARD,
    height: HEADER.H_DASHBOARD_DESKTOP,
    display: 'flex',
    alignItems: 'left',
    marginBottom: 0.5,
    justifyContent: 'left',
    padding: theme.spacing(1, 1.5),
    backgroundColor: '#1c84c6',
}));
// ----------------------------------------------------------------------
let ProClaimzAPIURL = '';

export function getProClaimzAPIURL() {
    return ProClaimzAPIURL;
}
export default function NavAccount() {
    const navigate = useNavigate();
    const [userData, setUserData] = useState([]);


    useEffect(() => {
        const CurrentLoggedInUser = AppCache.GetCurrentLoggedInUser();

        if (CurrentLoggedInUser && CurrentLoggedInUser.Token) {
            axios.defaults.headers.common.authheader = `${CurrentLoggedInUser.Token}`;
            axios.defaults.headers.common['Content-Type'] = 'application/json';
            UserNameService.then((userNameServiceInstance) => {
                userNameServiceInstance.GetUserName()
                    .then((response) => {
                        if (response.status === 200) {
                            setUserData(response.data);
                            sessionStorage.setItem('userName', response.data[0]?.UserName)
                            ProClaimzAPIURL = response.data[0]?.ProClaimzAPIURL;
                        } else {
                             //  console.log("Error while fetching user data. Status:", response.status);
                             //  console.log("Error Message:", response.data);
                        }
                    })
            })
                .catch((error) => {
                     //  console.log("Error:", error);
                });
        } else {
             //  console.log("Token not available");
        }
    }, []);



    return (
        <>
            {/* <CustomAvatar src={user?.photoURL} alt={user?.displayName} name={user?.displayName} />

      <Box sx={{ ml: 2, minWidth: 0 }}>
        <Typography variant="subtitle2" noWrap>
          {user?.displayName}
        </Typography>

        <Typography variant="body2" noWrap sx={{ color: 'text.secondary' }}>
          {user?.role}
        </Typography>
      </Box> */}

  


            <StyledLogo>
                <Box
                    onClick={() => navigate('/main/user-profile')}
                    sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                >
                    <Avatar alt="photoURL" sx={{ color: 'white' }} />
                    <Typography
                        variant="subtitle2"
                        noWrap
                        sx={{ color: 'white', fontWeight: 800, align: 'center', ml: 1 }}
                    >
                        {userData[0]?.UserName}
                    </Typography>
                </Box>
            </StyledLogo>

        </>
    );
}


          //  onClick={() => navigate('/main/user-profile')}